import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Logo from '../../components/Common/Logo';
import topBg from '../../images/top_background.png';
import cardBecomeAProOne from '../../images/card_become_a_pro_one.png';
import cardBecomeAProTwo from '../../images/card_become_a_pro_two.png';
import useUserDetailsById from '../../hooks/useUserDetailsById';
import {
  createSubscriptionPlanOnSignup,
} from "../../services/PlanService";
import {
  getUserType,
  getLocalStorage,
  setLocalStorage,
} from "../../helpers/common";
import { USER_INFO_KEY } from "../../constants/common";
import PremiumPlanModal from "../../components/PlanUpgrade/PremiumPlanModal";
import { toast } from "react-toastify";
import { pageURLs } from "@/constants";


export const CurvedTopHeader = () => (
  <div className="new-curved-header">
    <div className="bg-wrapper">
      <img src={topBg} alt="" />
    </div>
    <div className="logo-wrapper">
      <Logo type="logoWhite" />
    </div>
  </div>
);


const SelectYourPlan = () => {

  const userDetails = useUserDetailsById()

  const userType = getUserType();

  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);

  const navigate = useNavigate();

  const PremiumPlanModalClose = () => setPremiumPlanModal(false);

  const handleSkip = async () => {
    const data = {
      PlanName: "Lite",
      PlanPeriod: 1,
      UserType: userType,
    };

    try {
      const response = await createSubscriptionPlanOnSignup(data);
      if (response.errorCode === 0) {
        toast.dismiss();
        toast.success("You've selected Lite!");
        const userInfo = getLocalStorage(USER_INFO_KEY);
        userInfo.userInfo["planStatus"] = true;
        setLocalStorage(USER_INFO_KEY, userInfo);
        navigate(pageURLs.completeYourProfileDefault);
      } else {
        toast.error(
          "Something went wrong, while skipping the plan, please try again",
        );
      }
    } catch (error) {
      const hasUserAlreadySubscribedToPlan = error.response?.data?.errorCode?.status === 'UserPlanExists'
      if (hasUserAlreadySubscribedToPlan) {
        // there was an issue where some old accounts had a plan subscription active but the userInfo['planStatus'] was not set to true, this was causing the system to display the
        // become a pro page and to block the user from advancing when clicking the skip button because the plan was already subscribed and you can't subscribe twice.
        // This if here is for the purpose of fixing the flow for those old accounts.
        const userInfo = getLocalStorage(USER_INFO_KEY);
        userInfo.userInfo["planStatus"] = true;
        setLocalStorage(USER_INFO_KEY, userInfo);
        navigate(pageURLs.home);
        return
      }
      toast.error(
        "Something went wrong, while skipping the plan, please try again",
      );
    }
  }

  const handleGoPremium = () => {
    setPremiumPlanModal(true)
  }

  return (
    <>
      <CurvedTopHeader />
      <div className="select-plan-page">
        <div>
          <h1 className="title">
            Become a Pro Member Today for <span className="highlight">50% Off</span>
          </h1>
          <p className="subtitle">
            Pro Members receive over <span className="underline">10x more opportunities</span> on average through Gitcha
          </p>

          <div className="cards-wrapper">
            <div className="plan-img-card">
              <img src={cardBecomeAProOne} alt="Lite Agent card" className="plan-img" />
              <p className="plan-label">Lite Agent (free)</p>
            </div>

            <div className="plan-img-card selected">
              <img src={cardBecomeAProTwo} alt="Pro Member Agent card" className="plan-img" />
              <p className="plan-label green">Pro Member Agent<br />($15/month) $7.50/month annually</p>
            </div>
          </div>

          <div className="actions">
            <button className="btn-new-outline-secondary" onClick={handleSkip}>Skip</button>
            <button className="btn primary" onClick={handleGoPremium}>Get Pro Member Benefits</button>
          </div>
        </div>
      </div>

      <PremiumPlanModal
        userDetails={userDetails}
        show={showPremiumPlanModal}
        onHide={() => {
          PremiumPlanModalClose();
          // navigate(pageURLs.completeYourProfilePremium);
        }}
        showPlanModal={true}
      />
    </>
  );
};

export default SelectYourPlan